import { DocumentDownload } from "iconsax-react-nativejs";
import { useTranslation } from "react-i18next";
import { Text, useWindowDimensions, View } from "react-native";
import ScButton from "../ui-kit/button";
import ScDropdown from "../ui-kit/dropdown-select";
import ScSearchInput from "../ui-kit/search-bar";

type SeasonOption = Readonly<{ label: string; value: string }>;

type SeasonToolbarProps = Readonly<{
	search: string;
	onSearchChange: (text: string) => void;
	seasonOptions: SeasonOption[];
	selectedSeasonId: string | null;
	onSeasonChange: (value: string) => void;
	isCurrentSeason: boolean;
	onExport?: () => void;
	isExporting?: boolean;
}>;

const SeasonToolbar = ({
	search,
	onSearchChange,
	seasonOptions,
	selectedSeasonId,
	onSeasonChange,
	isCurrentSeason,
	onExport,
	isExporting = false,
}: SeasonToolbarProps) => {
	const { t } = useTranslation();
	const { width } = useWindowDimensions();
	const isMobile = width < 768;

	return (
		<View className="flex-row items-center gap-3 md:gap-4 flex-wrap">
			{/* The three controls share one height so the row reads as a single
			    bar; each has different intrinsic content, so the height is fixed
			    rather than left to padding + line-height. */}
			<ScSearchInput
				containerClassName="flex-1 min-w-[150px] md:max-w-[260px] rounded-full h-10 md:h-11"
				placeholderKey="LABEL_SEARCH_USERS"
				value={search}
				onChangeText={onSearchChange}
				surface="screen"
			/>
			<ScDropdown
				options={seasonOptions}
				value={selectedSeasonId ?? ""}
				onChange={onSeasonChange}
				placeholder={t("LABEL_SELECT_SEASON")}
				triggerClassName="h-10 md:h-11 bg-chalk"
			/>
			{/* Export is a desktop affordance (file download), as in the design. */}
			{!isMobile && onExport && (
				<ScButton
					text="BTN_EXPORT"
					iconPosition="left"
					icon={<DocumentDownload />}
					mode="outlined"
					onPress={onExport}
					loading={isExporting}
					className="h-10 md:h-11"
				/>
			)}
			{isCurrentSeason && (
				<View className="flex-row items-center gap-1.5 ml-auto">
					<View className="w-2 h-2 rounded-full bg-jade" />
					<Text className="text-xs font-medium text-jade">
						{t("LABEL_CURRENT_SEASON")}
					</Text>
				</View>
			)}
		</View>
	);
};

export default SeasonToolbar;
